/*globals $*/
"use strict";

import Shuffle from 'shufflejs';

var Demo = function(element){
    this.categories = Array.from(document.querySelectorAll('.js-product-categories input'));
    this.collections = Array.from(document.querySelectorAll('.js-product-collection input'));
    this.artists = Array.from(document.querySelectorAll('.js-product-artists input'));

    this.url = $('#directorio').val();
    this.element = element;
    this.shuffle = new Shuffle(element, {
        //itemSelector: '.product',
        easing: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
        sizer: '.my-sizer-element',
    });

    this.filters = {
        collections: [],
        categories: [],
        artists: [],
    };

    this._bindEventListeners();
    this.addSorting();
};

Demo.prototype._bindEventListeners = function(){
    this._onCollectionChange = this._handleCollectionChange.bind(this);
    this._onCategoryChange = this._handleCategoryChange.bind(this);
    this._onArtistChange = this._handleArtistChange.bind(this);

    this.collections.forEach(function(input){
        input.addEventListener('change', this._onCollectionChange);
    }, this);

    this.categories.forEach(function(input){
        input.addEventListener('change', this._onCategoryChange);
    }, this);

    this.artists.forEach(function(input){
        input.addEventListener('change', this._onArtistChange);
    }, this);

};

Demo.prototype._getCurrentCollectionFilters = function(){
    return this.collections.filter(function(input){
        return input.checked;
    }).map(function(input){
        return input.value;
    });
};

Demo.prototype._getCurrentCategoryFilters = function(){
    return this.categories.filter(function(input){
        return input.checked;
    }).map(function(input){
        return input.value;
    });
};

Demo.prototype._getCurrentArtistFilters = function(){
    return this.artists.filter(function(input){
        return input.checked;
    }).map(function(input){
        return input.value;
    });
};


Demo.prototype._handleCollectionChange = function(){
    this.filters.collections = this._getCurrentCollectionFilters();
    this.filter();
};

Demo.prototype._handleCategoryChange = function(){
    this.filters.categories = this._getCurrentCategoryFilters();
    this.filter();
};

Demo.prototype._handleArtistChange = function(){
    this.filters.artists = this._getCurrentArtistFilters();
    this.filter();
};


Demo.prototype.filter = function(){
    if(this.hasActiveFilters()){
        this.shuffle.filter(this.itemPassesFilters.bind(this));
    } else {
        this.shuffle.filter(this.itemPassesFilters.bind(this));
    }
};

Demo.prototype.hasActiveFilters = function (){
    return Object.keys(this.filters).some(function(key){
        return this.filters[key].length > 0;
    }, this);
};

Demo.prototype.itemPassesFilters = function(element){
    var collections = this.filters.collections;
    var categories = this.filters.categories;
    var artists = this.filters.artists;

    var collection = element.getAttribute('data-collection');
    var category = element.getAttribute('data-category');
    var artist = element.getAttribute('data-artist');

    if(collections.length > 0){
        var found = false;
        collections.find(function(element) {
          if(collection.includes(element)){
            found = true;
          }
        });

        if(!found){
            return false;
        }
    }

    if(categories.length > 0){
        var found = false;
        categories.find(function(element) {
          if(category.includes(element)){
            found = true;
          }
        });

        if(!found){
            return false;
        }
    }

    if(artists.length > 0){
        var found = false;
        artists.find(function(element) {
          if(artist.includes(element)){
            found = true;
          }
        });

        if(!found){
            return false;
        }
    }


    return true;
};

Demo.prototype.addSorting = function () {
  document.querySelector('.sort-options').addEventListener('change', this._handleSortChange.bind(this));
};

Demo.prototype._handleSortChange = function (evt) {
  var value = evt.target.value;

  console.log( 'sorting' );

  function sortByDate(element) {
    return element.getAttribute('data-date-created');
  }

  function sortByPrice(element) {
    return parseFloat( element.getAttribute('data-price') );
  }

  var options;
  if (value === 'date-created') {
    options = {
      reverse: true,
      by: sortByDate,
    };
  } else if (value === 'lowest-price') {
    options = {
      by: sortByPrice,
    };
  } else if (value === 'highest-price') {
    options = {
      reverse: true,
      by: sortByPrice,
    };
  } else {
    options = {};
  }

  this.shuffle.sort(options);
};





/*////// NEWS  */

var DemoNews = function(element){
    this.types = Array.from(document.querySelectorAll('.js-news button'));

    this.url = $('#directorio').val();
    this.element = element;
    this.shuffle = new Shuffle(element, {
        //itemSelector: '.product',
        easing: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
        sizer: '.my-sizer-element',
        delimiter: ',',
    });

    this.filters = {
        types: [],
    };

    this._bindEventListeners();
};

DemoNews.prototype._bindEventListeners = function(){
    this._onTypeChange = this._handleTypeChange.bind(this);

    this.types.forEach(function(button){
        button.addEventListener('click', this._onTypeChange);
    }, this);

};
DemoNews.prototype._getCurrentTypeFilters = function(){
    return this.types.filter(function(button){
        return button.classList.contains('active');
    }).map(function(button){
        return button.getAttribute('data-value');
    });
};
DemoNews.prototype._handleTypeChange = function(evt){
    var button = evt.currentTarget;

    // Treat these buttons like radio buttons where only 1 can be selected.
    if (button.classList.contains('active')) {
        //button.classList.remove('active');
    } else {
        this.types.forEach(function (btn) {
          btn.classList.remove('active');
        });

        button.classList.add('active');
    }

    if ( button.getAttribute('data-value') == 'all' ){
        this.shuffle.filter(Shuffle.ALL_ITEMS);
    } else {
        this.filters.types = this._getCurrentTypeFilters();
        this.filter();
    }
};

DemoNews.prototype.filter = function(){
    if(this.hasActiveFilters()){
        this.shuffle.filter(this.itemPassesFilters.bind(this));
    } else {
        this.shuffle.filter(Shuffle.ALL_ITEMS);
        //this.shuffle.filter(this.itemPassesFilters.bind(this));
    }
};

DemoNews.prototype.hasActiveFilters = function (){
    return Object.keys(this.filters).some(function(key){
        return this.filters[key].length > 0;
    }, this);
};

DemoNews.prototype.itemPassesFilters = function(element){
    var types = this.filters.types;

    var type = element.getAttribute('data-post');

    if(types.length > 0){
        var found = false;
        types.find(function(element) {
          if(type.includes(element)){
            found = true;
          }
        });

        if(!found){
            return false;
        }
    }

    return true;
};




export const startShuffle = () => {

    if($(".shuffle-products").length > 0) {
        window.demo = new Demo(document.querySelector('.shuffle'));
    }


    if($(".shuffle-news").length > 0) {
        window.demoNews = new DemoNews(document.querySelector('.shuffle-news'));

        //var startFilterSearch = $('.js-shuffle-search').val();
        var startFilterSlug = $('#start-filter').attr('data-slug');

        if(startFilterSlug != 'null' && startFilterSlug != 'tot'){
            //window.demoNews.filters.editions.push( startFilterSlug );
            window.demoNews.filter();
        }
    }


}

